"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.setDefaultProviders = void 0;

var _Telemetry = require("./Telemetry");

var setDefaultProviders = function setDefaultProviders() {
  if (process.env.APP_ENABLE_TELEMETRY === 'true') {
    var ariaTelemetryModule = require('./AriaTelemetryProvider');

    var aria = new ariaTelemetryModule.AriaTelemetryProvider();

    _Telemetry.telemetry.addProvider(aria);

    _Telemetry.telemetry.setDefaultProvider(aria);

    if (process.env.APP_LOG_TELEMETRY_TO_CONSOLE === 'true') {
      var consoleTelemetryModule = require('./ConsoleTelemetryProvider');

      _Telemetry.telemetry.addProvider(new consoleTelemetryModule.ConsoleTelemetryProvider());
    }

    _Telemetry.telemetry.initialize();
  }
};

exports.setDefaultProviders = setDefaultProviders;